module.exports = __webpack_public_path__ + "img/big.fb681b8f.png";